import { useCallback, useEffect, useState } from 'react';

// public/index.html sets <html data-theme> before React loads (no flash);
// this hook reads it, toggles it and remembers an explicit choice.
const STORAGE_KEY = 'theme';
const root = () => document.documentElement;

const readStored = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

export function useColorMode() {
  const [mode, setMode] = useState(() => root().dataset.theme || 'light');

  const apply = useCallback((next, persist) => {
    root().dataset.theme = next;
    setMode(next);
    if (!persist) return;
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      // Private mode / blocked storage: the choice just won't persist
    }
  }, []);

  // Follow the OS setting until the visitor picks a mode themselves
  useEffect(() => {
    const query = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = (e) => {
      if (!readStored()) apply(e.matches ? 'dark' : 'light', false);
    };
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, [apply]);

  const toggle = () => apply(mode === 'dark' ? 'light' : 'dark', true);

  return { mode, toggle };
}
